import { Component } from '@angular/core';

/**
 * Tela "Seja um Contador Parceiro" (usuario comum).
 *
 * Mantem o header e a rota `/contador/solicitar`; o miolo (carregar situacao,
 * solicitar, tratar 422/erros, estados ja-contador / em-analise / formulario) e
 * delegado ao `SolicitarContadorPanelComponent` compartilhado.
 */
@Component({
  selector: 'app-solicitar-contador',
  templateUrl: './solicitar-contador.component.html',
  styleUrls: ['./solicitar-contador.component.scss'],
})
export class SolicitarContadorComponent {}
